import FileSaver from 'file-saver'

/**
 * ファイルサイズのB単位変換文字列を取得する
 * @param size ファイルサイズ
 * @returns 変換した文字列
 */
const convertByteDisp = (size: number): string => `${Number(size).toLocaleString()} B`

/**
 * ファイルサイズ単位変換文字列を取得する
 * 現状はGBまで対応。TB以降は非対応
 * @param size ファイルサイズ
 * @returns 変換した文字列
 */
const convertDisp = (size: number): string => {
  // 0の場合は0KB固定
  if (size === 0) {
    return `0 KB`
  }
  // 1K以下は1KB固定
  if (size < 1024) {
    return `1 KB`
  }
  // KB単位
  if (size < 1024 * 1024) {
    return `${Math.round(size / 1024)} KB`
  }
  // MB単位
  if (size < 1024 * 1024 * 1024) {
    return `${Math.round(size / (1024 * 1024))} MB`
  }
  // GB単位は少数点2桁まで表示する
  // GB単位で少数点を求めてから100倍したのを四捨五入して100で割る
  const tmp = size / (1024 * 1024 * 1024)
  const result = Math.round(tmp * 100) / 100
  return `${result} GB`
}

/**
 * URLエンコードしたファイル名をデコードして取得する
 * @param content  エンコードしたファイル名
 * @returns デコードしたファイル名
 */
const decodeFilename = (content: string) => {
  const name = content.substring(content.indexOf("''") + 2, content.length)
  // デコードするとスペースが"+"になるのでスペースへ置換する
  return decodeURI(name).replace(/\+/g, ' ')
}

/**
 * ファイルダウンロードを実施する
 * @param data ダウンロードするデータ
 * @param fileName ファイル名
 */
const filedownload = (data: Blob | string, fileName: string) => {
  // ダウンロード実行
  FileSaver.saveAs(data, fileName)
}
export { convertDisp, convertByteDisp, decodeFilename, filedownload }
